import { gql } from '@apollo/client';

const USER_VALIDATIONS_UPDATE = gql`
  mutation checkValidationsToBeDepriciated($email: String!, $tournament: Int!, $category: Int!, $primaryEmail: String) {
    checkValidationsToBeDepriciated(email: $email, tournament: $tournament, category: $category, primaryEmail: $primaryEmail)
  }
`;

export default USER_VALIDATIONS_UPDATE;
